import ImageWithFallback from 'src/components/ImageWithFallback';
import Link from 'next/link';
import { AppRoutes } from 'src/lib/routes';
import { Blog } from 'src/types';
import { truncate, escapeRegExp } from 'lodash-es';
import { humanize } from 'src/helpers';
import { HiOutlineArrowNarrowRight } from 'react-icons/hi';
import Highlighter from 'react-highlight-words';
import Skeleton from 'react-loading-skeleton';
import SkeletonTheme from 'src/components/SkeletonTheme';

type Props = {
  className?: string;
  textClassName?: string;
  blog: Blog;
  highlightText?: string
};

export const BlogCardSkeleton: React.FC = () => {
  return (
    <div>
      <SkeletonTheme>
        <div className="tw-h-60 tw-bg-grey-lightest tw-rounded-lg tw-mb-4"></div>
        <div className="tw-text-center tw-mb-4">
          <Skeleton className="tw-w-16 tw-inline-block" />
        </div>
        <Skeleton count={1} className="tw-mb-4" />
        <div className="tw-mb-4">
          <Skeleton count={2} />
        </div>
        <div className="tw-text-center">
          <Skeleton className="tw-w-24 tw-inline-block" />
        </div>
      </SkeletonTheme>
    </div>
  );
};

const BlogCardV2: React.FC<Props> = ({ blog, className, textClassName = 'tw-text-brand-navy', highlightText }) => {
  return (
    <div className={`tw-text-brand-navy ${className || ''}`}>
      <Link legacyBehavior prefetch={false} href={AppRoutes.shortMagazineRoute({ id: blog.slug }).toPath()}>
        <a className={textClassName}>
          <ImageWithFallback
            src={blog.coverMdImgUrl || blog.coverImgUrl}
            alt={blog.title}
            fill
            className="tw-object-cover tw-static tw-block tw-h-60 tw-rounded-lg tw-border-2 tw-border-solid tw-border-brand-green tw-mb-4"
            unoptimized={true}
          />
          <div className="tw-text-xs md:tw-text-sm tw-uppercase tw-font-semibold tw-mb-4 tw-text-center">{blog.topicName}</div>
          <div className="tw-mb-4 tw-text-center">
            <Highlighter
              searchWords={escapeRegExp(highlightText).split(' ')}
              className="tw-font-semibold tw-font-styleSans tw-text-xl md:tw-text-2xl tw-leading-none md:tw-leading-none tw-underline"
              textToHighlight={blog.title}
            />
          </div>
          <div className="tw-text-center">
            <Highlighter
              searchWords={escapeRegExp(highlightText).split(' ')}
              className="tw-text-sm md:tw-text-base"
              textToHighlight={truncate(blog.excerpt, { length: 60, omission: '...'})}
            />
          </div>
          <div className="tw-text-center tw-mt-4">
            <HiOutlineArrowNarrowRight size={24} className={textClassName} />
          </div>
        </a>
      </Link>
    </div>
  );
};

export default BlogCardV2;
